import apiService from './apiService';

class RakePointService {
  async getRakePoints(skip = 0, limit = 100, activeOnly = true) {
    try {
      const endpoint = `/api/v1/rake-points/?skip=${skip}&limit=${limit}&active_only=${activeOnly}`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch rake points:', error);
      throw error;
    }
  }

  async getRakePointsDropdown(pointType = '') {
    try {
      let endpoint = '/api/v1/rake-points/dropdown';
      if (pointType) {
        endpoint += `?point_type=${pointType}`;
      }
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error('Failed to fetch rake points dropdown:', error);
      throw error;
    }
  }

  async getRakePointById(id) {
    try {
      const endpoint = `/api/v1/rake-points/${id}`;
      const response = await apiService.get(endpoint);
      return response;
    } catch (error) {
      console.error(`Failed to fetch rake point with ID ${id}:`, error);
      throw error;
    }
  }

  async createRakePoint(rakePointData) {
    try {
      const endpoint = '/api/v1/rake-points/';
      const response = await apiService.post(endpoint, rakePointData);
      return response;
    } catch (error) {
      console.error('Failed to create rake point:', error);
      if (error.message && error.message.includes('already exists')) {
        throw new Error('A rake point with this code already exists. Please use a different code.');
      }
      throw error;
    }
  }

  async updateRakePoint(id, rakePointData) {
    try {
      const endpoint = `/api/v1/rake-points/${id}`;
      const response = await apiService.put(endpoint, rakePointData);
      return response;
    } catch (error) {
      console.error(`Failed to update rake point with ID ${id}:`, error);
      if (error.message && error.message.includes('already exists')) {
        throw new Error('A rake point with this code already exists. Please use a different code.');
      }
      throw error;
    }
  }

  async deleteRakePoint(id) {
    try {
      const endpoint = `/api/v1/rake-points/${id}`;
      const response = await apiService.delete(endpoint);
      return response;
    } catch (error) {
      console.error(`Failed to delete rake point with ID ${id}:`, error);
      throw error;
    }
  }

  async activateRakePoint(id) {
    try {
      const endpoint = `/api/v1/rake-points/${id}/activate`;
      const response = await apiService.patch(endpoint);
      return response;
    } catch (error) {
      console.error(`Failed to activate rake point with ID ${id}:`, error);
      throw error;
    }
  }
}

export default new RakePointService();
